import {Context, useContext} from 'react'
import {HeaderProps} from 'react-table'

// Define the expected properties for SelectionHeader
export interface SelectionHeaderProps<T extends object, C> {
  tableProps: HeaderProps<T>
  context: Context<C>
}

const SelectionHeader = <T extends object, C>({
  tableProps,
  context,
}: SelectionHeaderProps<T, C>) => {
  const {isAllSelected, onSelectAll} = useContext(context) as unknown as {
    isAllSelected: boolean
    onSelectAll: () => void
  }

  const {key, ...headerProps} = tableProps.column.getHeaderProps()

  return (
    <th key={key} {...headerProps} className='w-10px pe-2'>
      <div className='form-check form-check-sm form-check-custom form-check-solid me-3'>
        <input
          className='form-check-input'
          style={{border: '1px solid #6d6d80'}}
          type='checkbox'
          data-kt-check={isAllSelected}
          data-kt-check-target='#kt_table_users .form-check-input'
          checked={isAllSelected}
          onChange={onSelectAll}
        />
      </div>
    </th>
  )
}

export default SelectionHeader
